import { useEffect } from 'react';

const DOMAIN = 'https://netauctionsinc.com';

const upsertMeta = (attr, key, content) => {
  if (!content) return null;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
  return el;
};

const upsertLink = (rel, href) => {
  if (!href) return null;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
  return el;
};

/**
 * SEO head manager (React 19 safe, no external dep).
 * Sets title/meta/canonical + injects JSON-LD schema blocks.
 * Googlebot renders the DOM, so these are indexed like SSR meta.
 */
export const Seo = ({ title, description, canonicalPath, jsonLd, robots }) => {
  useEffect(() => {
    if (title) document.title = title;
    const canonical = canonicalPath ? `${DOMAIN}${canonicalPath}` : null;

    upsertMeta('name', 'description', description);
    upsertMeta('name', 'robots', robots || 'index,follow,max-image-preview:large,max-snippet:-1');
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:url', canonical);
    upsertMeta('property', 'og:site_name', 'Net Auctions');
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertLink('canonical', canonical);

    const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
    const nodes = blocks.map((block) => {
      const s = document.createElement('script');
      s.type = 'application/ld+json';
      s.setAttribute('data-seo-jsonld', 'true');
      s.text = JSON.stringify(block);
      document.head.appendChild(s);
      return s;
    });

    return () => {
      nodes.forEach((n) => n.remove());
    };
  }, [title, description, canonicalPath, robots, JSON.stringify(jsonLd)]);

  return null;
};
